/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Empty_TitleInputs */

const en_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const de_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const fr_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const es_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const it_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const nl_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const pl_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const fi_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const da_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

const sv_story_bank_empty_title = /** @type {(inputs: Story_Bank_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No interview stories yet`)
};

/**
* | output |
* | --- |
* | "No interview stories yet" |
*
* @param {Story_Bank_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_empty_title = /** @type {((inputs?: Story_Bank_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_empty_title(inputs)
	if (locale === "fr") return fr_story_bank_empty_title(inputs)
	if (locale === "es") return es_story_bank_empty_title(inputs)
	if (locale === "it") return it_story_bank_empty_title(inputs)
	if (locale === "nl") return nl_story_bank_empty_title(inputs)
	if (locale === "pl") return pl_story_bank_empty_title(inputs)
	if (locale === "fi") return fi_story_bank_empty_title(inputs)
	if (locale === "da") return da_story_bank_empty_title(inputs)
	if (locale === "sv") return sv_story_bank_empty_title(inputs)
	return en_story_bank_empty_title(inputs)
});